import { render, staticRenderFns } from "./NewSelectFieldWidget.vue?vue&type=template&id=794586c3&"
import script from "./NewSelectFieldWidget.vue?vue&type=script&lang=ts&"
export * from "./NewSelectFieldWidget.vue?vue&type=script&lang=ts&"
import style0 from "./NewSelectFieldWidget.vue?vue&type=style&index=0&id=794586c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports